import { useEffect } from 'react';

/**
 * Custom hook to set the browser tab title dynamically
 * @param {string} pageTitle - The name of the current page/panel
 * @param {string} appName - The app name (default: "SK")
 */
const usePageTitle = (pageTitle, appName = "SK") => {
  useEffect(() => {
    const previousTitle = document.title;
    
    if (pageTitle) {
      document.title = `EximFlow | ${pageTitle}`;
    } else {
      document.title = "EximFlow";
    }
    
    // Cleanup: restore previous title when component unmounts
    return () => {
      document.title = previousTitle;
    };
  }, [pageTitle, appName]);
};

export default usePageTitle;
